import { Component } from 'react';
interface FaqData {
  question: string;
  answer: string;
}

interface Props {
  data: FaqData;
  mandate: boolean;
}

class Group extends Component<Props> {
  constructor(props: any) {
    super(props);
    this.state = {
      open: props.mandate || false,
    };
  }
  public render() {
    const { question, answer } = this.props.data;
    return (
      <div className="lil-my-12">
        <h6 className="lil-text-white lil-my-4">{question}</h6>
        <p className="lil-text-grey-450">{answer}</p>
      </div>
    );
  }
}

// tslint:disable-next-line:max-classes-per-file
class FAQNew extends Component<any, any> {
  constructor(props: any) {
    super(props);
  }
  public render() {
    const { faqs, mandate } = this.props;
    const faqsToLoad = faqs;
    return (
      <div className="lil-w-full lil-bg-font-500 ">
        <div className="lil-container lil-pt-8 lil-mb-0">
          <div className="lil-items-center lil-py-24 sm:lil-py-12">
            <h2 className="lil-text-white lil-text-center lil-font-bold">
              Frequently Asked Questions
            </h2>
            {faqsToLoad.map(group => (
              <Group mandate={mandate} data={group} key={group.answer} />
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default FAQNew;



// WEBPACK FOOTER //
// ./components/plan/faqNew.tsx